/* 用户端专属 state getter */
export const userInfo = state => state.userInfo;
export const buyInfo = state => state.buyInfo;
export const payInfo = state => state.payInfo;
export const preOrderInfo = state => state.preOrderInfo;
export const payStatus = state => state.payStatus;

// 用户端
export const catagoryList = state => state.catagoryList;
export const advertList = state => state.advertList;            // 首页轮播
export const indexCourseList = state => state.indexCourseList;  // 首页列表
export const indexCourseObj = state => state.indexCourseObj;    // 首页请求下一页参数对象
export const userIssues = state => state.userIssues;                    // 问题库列表
export const userCourse = state => state.userCourse;              // 我的开讲列表
export const combineCourse = state => state.combineCourse;              // 我的组合课
export const userSerialCourse = state => state.userSerialCourse; // 我的开讲系列课
export const sedCodeInfo = state => state.sedCodeInfo; // 发送验证码
export const bindMobileInfo = state => state.bindMobileInfo; // 发送验证码
export const treeCoinInfo = state => state.treeCoinInfo; // 树币
export const hotLabelList = state => state.hotLabelList;
export const lamaRecommends = state => state.lamaRecommends;
export const freeTinyCourse = state => state.freeTinyCourse;

// 组合课程
export const groupAlbum = state => state.groupAlbum;
export const myCourse = state => state.myCourse;

// 用户端-我的音频
export const myTinyAudio = state => state.myTinyAudio;
export const myTinyVideo = state => state.myTinyVideo;
export const myTinyAlbum = state => state.myTinyAlbum;
export const myTinyVideoAlbum = state => state.myTinyVideoAlbum;
export const audio5 = state => state.audio5;

export const indexInfo = state => state.indexInfo;
export const isSort = state => state.isSort; // 订阅课子课列表中是否进行了排序
export const columnList = state => state.columnList; // 订阅课子课列表中是否进行了排序
export const leaveMessageList = state => state.leaveMessageList; // 子课程详情留言列表
export const newCourseInfo = state => state.newCourseInfo; // 新版课程详情
export const myIncome = state => state.myIncome; // 我的收益
export const constantData = state => state.constantData; // 获取后台配置的静态数据
export const vipInfo = state => state.vipInfo; // VIP静态数据
export const memberFreeCourse = state => state.memberFreeCourse; // 会员免费听
export const indexModuleList = state => state.indexModuleList; // 新版首页 模块列表 2018-6-21
export const freeAnsCount = state => state.freeAnsCount; // 专家免费回答数



// WEBPACK FOOTER //
// ./src/store/user/getters.user.js